const questionSelectionActions = {
    types: {
        QUESTION_SELECTION_SET_SELECTION: 'QUESTION_SELECTION_SET_SELECTION',
        QUESTION_SELECTION_RESTORE: 'QUESTION_SELECTION_RESTORE',
    },

    setSelection(contentRevisionId, selection) {
        return { type: this.types.QUESTION_SELECTION_SET_SELECTION, contentRevisionId, selection };
    },

    restoreQuestionsSelection(questionSelection) {
        return { type: this.types.QUESTION_SELECTION_RESTORE, questionSelection };
    },
};

export default questionSelectionActions;
